import React from "react";
import { ActivityTimeline } from "@photon/chat-react/activity-timeline";
import TimelineItem from "../../../shared/Timeline/TimelineItem";
import useStreamingStateStore from "../../../../store/useStreamingStateStore";

export const ShowResearch = ({
  activityOpen,
  setActivityOpen,
  researchData,
  message_id,
  answerContent,
}) => {
  const isStreaming = useStreamingStateStore(
    (state) => !!state.activeStreams[message_id]?.streaming
  );

  return (
    <ActivityTimeline
      items={researchData}
      isStreaming={isStreaming}
      answerContent={answerContent}
      expanded={activityOpen}
      onExpandedChange={setActivityOpen}
      variant="page"
      renderItem={({ item, index, expanded, onToggle, isActiveItem }) => (
        <TimelineItem
          item={item}
          index={index}
          isApprovalItem={item?.type === "approval"}
          approvalStatus={item?.status}
          isStreaming={isStreaming}
          isActiveItem={isActiveItem}
          expanded={expanded}
          onToggle={onToggle}
        />
      )}
    />
  );
};